import React ,{ useState , useEffect}from 'react';
import { useSelector , useDispatch} from 'react-redux';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { queryClient } from '../../state/queryClient';
import { useUser  } from '../../state/reactquery';
import { addEltHistory } from '../../state/reactquery';

import { defineAttachments,defineObjet,defineMessage,modifyDisplaymodal,defineMessagetexte} from "../../state/redux";
import { actionenvoimaildevis } from '../../utils/actions_devis';


import { sendemail } from '../../utils/email';

import { axios_email_transfer } from '../../axios/axios_email';
import { modifyonelead } from '../../utils/actions_lead';
import { valideemail } from '../../utils/validations';
import { modules , max_size_attachements , replaceTags , templatemessage_comtoclient , templatemessage_gestion , templatemessagetexte_comtoclient} from '../../utils/utils_windownail';

import ButtonSend from '../Buttons/ButtonSend';
import croixclose from '../../images/croixclose.svg'; 
import uploaddel from '../../images/uploaddel.svg'; 

import './WindowMail.scss';



function WindowMail({leadactu={},emailTo,closewindow,widthsize}) {
  const dispatch =useDispatch() ;
  const {data: user} = useUser(localStorage.getItem('token'))  ;
  const {ecran }= useSelector(state=>state.display);
  const {attachments,objet,message,typemail ,idmailtransfer,attachlinkmailtransfer} = useSelector(state=>state.email);



useEffect (()=>{
  if(typemail==='ficheclient' || typemail==='comtoclient'){setLocalmessage(templatemessage_comtoclient(leadactu, user)) ; 
                                dispatch(defineMessage(templatemessage_comtoclient(leadactu, user)))  ;
                                dispatch(defineMessagetexte(templatemessagetexte_comtoclient(leadactu, user)))  ;}
  if(typemail==='gestion' || typemail==='comtoclient'){setLocalmessage(templatemessage_gestion(user)) ; 
                                  dispatch(defineMessage(templatemessage_gestion(user)))  ;
                                  dispatch(defineMessagetexte(templatemessagetexte_comtoclient(leadactu, user)))  ;}
                    
},[leadactu,user,dispatch,typemail])


  const [localmessage, setLocalmessage] = useState(message) ;

  const [email2, setEmail2] = useState('') ;
  const [emailto,setMailto] = useState('') ;
  const [totalsize, settotalsize] = useState(0);
  const [loading , setLoading ] = useState(false);

  const disable = objet?.trim()==='' || localmessage?.trim()==='' || totalsize>max_size_attachements || 
                (email2.length >0 && !valideemail(email2)) || ((typemail === 'newmessage'  || typemail==='transfer') && !valideemail(emailto))  ;

  useEffect(()=>{settotalsize([...attachments].map(x=>x.size).reduce((acc,x)=>acc+x,0))}, [attachments])

  const handleFileChange = (e) => {dispatch(defineAttachments([...attachments,...e.target.files]))};

const envoyermessage = async () => {
    setLoading(true);
    const email_destinataire =(typemail === 'newmessage' || typemail==='transfer')?emailto : emailTo ; 

    let jsonemailsend = {lead:leadactu, email:email_destinataire, email2:email2, objet:objet, message:localmessage, messagetexte:replaceTags(localmessage)} ;
   
   let url = null ;
    if(typemail !=='transfer'){jsonemailsend['attachments'] = [...attachments] ; url = await sendemail(jsonemailsend);}
    else{ jsonemailsend['idmailtransfer'] =idmailtransfer ; await axios_email_transfer(jsonemailsend);  }

    if(ecran==='ecrangestion' && typemail !=='transfer'){addEltHistory(leadactu.id,'email', `<div class='horoline1' > Email <span  className='horolink' >${objet} </span> envoyé par ${user.firstname} ${user.lastname}.</div>`);}
    else if (typemail === 'envoidevis') { actionenvoimaildevis(url) }
    else  if(typemail==='ficheclient' || typemail==='comtoclient'){await addEltHistory(leadactu.id,'email', `<div class='horoline1' > Email <span  className='horolink' >${objet} </span> envoyé. </div>`)}
    setLoading(false);
    dispatch(defineAttachments([]));
    dispatch(defineObjet(''));
    dispatch(defineMessage(''));
    dispatch(defineMessagetexte(''));
    queryClient.invalidateQueries({ queryKey: ['clientmails', user['postmail'], leadactu.email] });
    queryClient.invalidateQueries({ queryKey: ['listmails'] }); 
    queryClient.invalidateQueries({ queryKey: ['listgestionmails']})  ; // DEV VOIR PAR RAPPORT A OU ON EST 

    if (leadactu.statut_client === '' || leadactu.statut_client === undefined) { modifyonelead({ statut_client: 'contact' }); }
         dispatch(modifyDisplaymodal(null))
    closewindow() ;
    
}

  const deletefilefromliste = (e)=>{dispatch(defineAttachments([...attachments].filter(x=>x.name!==e.target.id)));}
    
    return(<div className={`windowmail_container ${widthsize}`}   >
                      <img  className='windowmail_close' src={croixclose}  onClick={()=>{  closewindow() ;      dispatch(modifyDisplaymodal(null)) ;   dispatch(defineAttachments([]));   }}  alt="croixclose"   /> 

                      {(typemail === 'newmessage' || typemail === 'transfer')?<><input  className='windowmail_input'    placeholder='Destinataire'  value={emailto}  onChange={(e)=>{setMailto(e.target.value)}}   />
                      </>:<div className='windowmail_top' > Nouveau Message à <span>{emailTo}</span></div>}                    
                        <input  className='windowmail_input'    placeholder='Objet'  value={objet}  onChange={(e)=>{dispatch(defineObjet(e.target.value))}}   />
                        <input  className='windowmail_input'    placeholder="Copie" value={email2}  onChange={(e)=>{setEmail2(e.target.value)}}  />
                 
                 <div className={`container_reactquill ${typemail}`}>
                 <ReactQuill theme= 'snow'
                                placeholder={'Write your message'}
                                modules={modules}
                                value={localmessage}   
                                onChange={setLocalmessage} />

                 </div>
  
                

                    <div className='windowmail_bottom displayflex'>
                    { totalsize>max_size_attachements &&  <div className='messagefilesbig' >La taille totale des fichiers ne doit pas excéder 4mo</div>}
                   
                    { typemail!=='transfer' ? <div className='displayflex'>
                                                  <div className="inputmessageattachement_container">
                                                      <input type="file"  multiple onChange={handleFileChange} />
                                                  </div>
                                                  <div className='containerlistenamefiles'>
                                                        {[...attachments].map((x, index)=>(<div  key={index}  className='divfilenameinliste' >
                                                                                          <div className='filenameinliste' id={x.name} key={x.name}   >{x.name}</div>
                                                                                          <img id={x.name} className="uploaddel" src={uploaddel} alt='imgdel'  onClick={deletefilefromliste} />
                                                                                  </div>))}
                                                  </div> 
                                                </div>:
                                                <div className='displayflex wd400' >{attachlinkmailtransfer.map((x,index)=><div key={index} className='filenameinliste'>{x.split('/')?.reverse()?.[0] }</div>)}</div>
                                                } 

                     <ButtonSend texte="Envoyer" 
                                  color={disable?'color_disable':'color_blue'}
                                  size='bouton_size_normal' 
                                  image='imagemail' 
                                  loading={loading}
                                  onclick={envoyermessage} />
                    </div>
              </div>)
}


export default WindowMail